import { FeatureAccessEntitlementsResponseDto } from '../dtos/entitlement.dto';
import {
  EntitlementFeatureKey,
  FeatureEntitlement,
} from '../../models/entitlement.model';

export class EntitlementMapper {
  public fromResponse(
    dto: FeatureAccessEntitlementsResponseDto,
  ): FeatureEntitlement[] {
    return dto.Entitlement.map((item) => ({
      ...item,
      featureKey: item.featureKey as EntitlementFeatureKey,
      operator: { ...item.operator },
      supplier: { ...item.supplier },
      buyer: { ...item.buyer },
    }));
  }
}
